import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddDevLayer from "../../components/Devs/AddDevLayer";




const AddDevPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  title="Add Dev" />

        {/* Add Dev Layer */}
        <AddDevLayer />

      </MasterLayout>
    </>
  );
};

export default AddDevPage;
